import api from './axiosInstance';
import {NewCategory} from "../types";

export const getCategories = async () => {
    const response = await api.get('/method/notes.notes.api.category.get_all_categories/');
    return response.data.data;
};

export const getCategoryByCategory = async (category: string) => {
    const response = await api.get(`/method/notes.notes.api.category.get_category_by_category/${category}`);
    return response.data.data;
};

export const createCategory = async (category: NewCategory) => {
    const response = await api.post('/resource/Category/', category);
    return response.data.data;
};

export const updateCategory = async (id: string, category: any) => {
    const response = await api.put(`/resource/Category/${id}`, category);
    return response.data.data;
};

export const deleteCategory = async (id: string) => {
    await api.delete(`/resource/Category/${id}`);
};
